export default __webpack_public_path__ + "static/media/ninjatag_PRZEJSCIE.1818f239.gif";